import CardWrapper from "components/Common/CardWrapper";
import PageHeader from "components/Forex/Common/PageHeader";
import React, { useEffect, useState } from "react";
import { 
  Col, Container, Row
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useSelector } from "react-redux";
import GeneratePDF from "./generatePDF";
import PreviewPDF from "./PreviewPDF";
import { signOnDocuments } from "../../Documents/DocumentsE-signature/signOnDucements.js";

function Applications() {
  const { t } = useTranslation();
  const kuwaitDocuments = ["Kuwait_KYC_1", "Kuwait_KYC_2"];
  const {
    fx: { isIb, isClient },
    isCorporate,
    nationality,
    firstName,
    lastName,
    country,
  } = useSelector(state => state.Profile.clientData);
  const [signedUrls, setSignedUrls] = useState([]);
  const isKuwaiti = nationality === "Kuwait" || country === "Kuwait";
  useEffect(() => {
    if (!firstName || !lastName) return; 

    const getSignedUrls = async () => {
      const signedUrls = await Promise.all(
        kuwaitDocuments.map(handleSignedUrl)
      );
      setSignedUrls(signedUrls);
    };

    getSignedUrls();
  }, [firstName, lastName]); 
  const handleSignedUrl = async fileName => {
    const signedFile = await signOnDocuments(
      fileName,
      `${firstName} ${lastName}`
    );
    const blobUrl = URL.createObjectURL(signedFile);
    return blobUrl;
  };
  const aplicationTitles = [];
  if (isCorporate && isClient)
    aplicationTitles.push({
      title: t("Corporate Application"),
      isIb: false,
    });
  else if (!isCorporate && isClient && !isKuwaiti)
    aplicationTitles.push({
      title: t("Individual Application"),
      isIb: false,
    });
  if (isCorporate && isIb)
    aplicationTitles.push({
      title: t("Corporate IB Application"),
      isIb: true,
    });
  else if (!isCorporate && isIb)
    aplicationTitles.push({
      title: t("Broker Application"),
      isIb: true,
    });
  if (isKuwaiti){
    aplicationTitles.push({
      title: t("Civil ID Requirements"),
      isIb: true,
      fileUrl: signedUrls[0],
    });
    aplicationTitles.push({
      title: t("Address Proof Guidelines"),
      isIb: true,
      fileUrl: signedUrls[1],
    });
  }
  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>{t("Applications")}</title>
        </MetaTags>
        <Container className="mt-5">
          <PageHeader title="My Applications" />
          <CardWrapper className="mt-5 px-5 py-4 glass-card shadow">
            <Row>
              <Col className="d-flex justify-content-between">
                <h3 className="color-primary">{t("My Applications")}</h3>
              </Col>
            </Row>
            {aplicationTitles.map((app, index) => (
              <div
                key={index}
                className="mt-3 pb-3 d-flex border-bottom justify-content-between align-items-center"
              >
                <span className="me-auto">{app.title}</span>
                <PreviewPDF heading={app.title} isIb={app.isIb} t={t} fileUrl={app.fileUrl} />
                <GeneratePDF heading={app.title} isIb={app.isIb} t={t} fileUrl={app.fileUrl} />
              </div>
            ))}
          </CardWrapper>
        </Container>
      </div>
    </>
  );
}

export default Applications;
